<!-- TEXTBOX -->

<section class="enroll-section-body">
  <div class="field-title">ZipCode</div>
  <div class="content-grey ng-binding" >{{zipcountyState.zipCode}}</div>
  <div class="field-title">County</div>
  <div class="content-grey ng-binding" >{{zipcountyState.county.county}}</div>
  <div class="field-title">State</div>
  <div class="content-grey ng-binding" >{{zipcountyState.county.state}}</div>
</section>
